



















































































































import Vue from 'vue'
import SupplierResourceDownload from '@/product/components/SupplierResourceDownload.vue'
import { TextLink } from '@raksul/raksul-common-ui'
import { getJsonData } from '@/common/utils/dom'
import { GUIDE_LINK } from '@/common/const'
import { data} from '@/product/selectors'
import { UserInfo } from '@/types/common'
import { SUPPLIER_RESOURCE_BY_PRODUCT } from '@/product/const'

export default Vue.extend({
  components: {
    TextLink,
    SupplierResourceDownload
  },
  data(): {
    supplierResourceDownloadLink: string,
    isUserLogin: boolean
  } {
    return {
      supplierResourceDownloadLink: '',
      isUserLogin: false
    }
  },
  computed: {
    pathDataLink():string {
      return GUIDE_LINK.CREATE_PATH_DATA
    },
    productAiTemplateUrl(): string {
      return this.$store.state.productAiTemplateUrl
    },
    fileExtensionsFormat(): string {
      return this.$store.getters.fileExtensionsFormat
    },
    isAIExtension(): boolean {
      return this.$store.getters.isAIExtension
    }
  },
  mounted() {
    this.$nextTick(() => {
      const productId = this.$route.params.id
      const downloadLink = SUPPLIER_RESOURCE_BY_PRODUCT[productId]
      const loggedInUser: UserInfo = getJsonData(data.currentUser)
      if (loggedInUser) {
        this.isUserLogin = true
      }
      if (downloadLink) {
        this.supplierResourceDownloadLink = downloadLink
      }
    })
  }
})
